import React, { useState, createContext } from 'react';

export const FiltersContext = createContext();

export const FiltersProvider = (props) => {
  const [filters, setFilters] = useState([
    {
      id: 'tier1',
      label: '£10',
      colour: 'primary',
      active: true,
    },
    {
      id: 'tier2',
      label: '£50',
      colour: 'secondary',
      active: true,
    },
    {
      id: 'tier3',
      label: '£250',
      colour: 'tertiary',
      active: true,
    },
  ]);

  return (
    <FiltersContext.Provider value={[filters, setFilters]}>
      {props.children}
    </FiltersContext.Provider>
  );
};
